<form [formGroup]="form" (ngSubmit)="addTurnInformation()" class="dialog-form">

  <h2 mat-dialog-title class="dialog-header">
    <span>{{ 'control.notes' | translate }}</span>
    <button mat-icon-button mat-dialog-close type="button">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div mat-dialog-content class="dialog-content">
    <div class="row">
      <div class="col-12">
        <h5 class="header-title">{{ 'control.turn value' | translate }}:</h5>
        <mat-form-field appearance="outline" class="w-100" color="primary">
          <input matInput type="text" formControlName="notes" (keyup.enter)="addTurnInformation()"/>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button color="warn" type="button" (click)="cancel()">{{ 'global.cancel' | translate }}</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">{{ 'global.accept' | translate }}</button>
  </div>

</form>
